import api, { normalizeEndpoint } from './httpClient';

export const authService = {
  // Login user
  login: async (email, password) => {
    try {
      const response = await api.post(normalizeEndpoint('auth/login'), { email, password });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Login failed');
    }
  },

  // Get current user
  getCurrentUser: async () => {
    try {
      const response = await api.get(normalizeEndpoint('auth/me'));
      return response.data.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to get user data');
    }
  },


};
